import React, { Fragment, Suspense, useMemo } from 'react';
import {
  Switch,
  BrowserRouter as Router,
  Route,
  Redirect
} from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import * as Container from 'Containers';
import RouteSchema from './Routes';

export const navigation = RouteSchema.authorized.map((r) => ({
  name: r.name,
  path: r.path,
  siblings: r.siblings || null
}));

export default function Routes() {
  const { initialized, keycloak } = useKeycloak();

  let mapPaths = (r) => {
    let siblings = r.siblings?.map((s) => s?.path);
    let nested = r.nested?.map((n) => n?.path);
    let routePath = r.path;
    if (nested?.length && siblings?.length)
      return [...nested, ...siblings, routePath];
    if (nested?.length) return [...nested, routePath];
    if (siblings?.length) return [...siblings, routePath];
    return routePath;
  };

  function mapRoutes(route) {
    if (route.siblings?.length) {
      return route.siblings?.map(mapRoutes);
    }
    return (
      <Fragment key={route?.name}>
        <Route
          path={route?.path}
          render={route?.render}
          exact={route?.exact}
          key={route?.name}
        />
        {route.nested?.map(mapRoutes)}
      </Fragment>
    );
  }

  let authorizedRoutes = RouteSchema.authorized?.map(mapRoutes);
  let unauthorizedRoutes = RouteSchema.unauthorized?.map(mapRoutes);
  let authorizedPaths = RouteSchema.authorized?.map(mapPaths).flat();
  let unauthorizedPaths = RouteSchema.unauthorized?.map(mapPaths).flat();

  return initialized ? (
    <Router>
      <Switch>
        <Route path="/" exact>
          <Redirect to="/login" />
        </Route>

        <Route path={unauthorizedPaths} exact>
          <Container.Unauthorized>
            <Switch>
              <Suspense fallback={false}>{unauthorizedRoutes}</Suspense>
            </Switch>
          </Container.Unauthorized>
        </Route>

        {keycloak.authenticated ? (
          <Route path={authorizedPaths} exact>
            <Container.Authorized>
              <Switch>
                <Suspense fallback={false}>{authorizedRoutes}</Suspense>
              </Switch>
            </Container.Authorized>
          </Route>
        ) : (
          <Route path={authorizedPaths} exact>
            <Redirect to="/login" />
          </Route>
        )}

        <Route path="*" render={() => <div>404</div>} />
      </Switch>
    </Router>
  ) : (
    <div>Loading...</div>
  );
}
